<template>
  <v-card flat outlined rounded="lg" height="100%" color="cardbg" elevation="10">
    <v-card-title
      color="primary"
      :style="`padding: calc(${scale} * 0.4rem);
       line-height: calc(${scale} * 0.75rem); font-size: calc(${scale} * 0.7rem);`"
      class="font-weight-medium d-flex justify-space-between"
    >
      <span class="titlecolor--text">Worst Issue Analysis & Improvement</span>
      <span class="subtitlecolor--text">{{ yesterday }}</span>
    </v-card-title>
    <v-card-text :style="`height: 90%; padding: calc(${scale} * 0.1rem) calc(${scale} * 0.4rem);`">
      <div style="height: 100%;">
        <WidgetLoading v-if="loading" />
        <table
          style="text-align: center;"
          class="w-full"
          :style="`font-size: calc(${scale} * 0.7rem); line-height: 1.4;`"
          v-else
        >
          <tr
            class="subtitlecolor--text font-weight-regular text-uppercase text-left"
            :style="`font-size: calc(${scale} * 0.7rem);`"
          >
            <th class="px-1">Part Name</th>
            <th class="px-1">Defect</th>
            <th class="px-1">Analysis</th>
            <th class="px-1">Temp. Action</th>
            <th class="px-1">Permanent Action</th>
          </tr>
          <tr class="text-left titlecolor--text" v-for="(part, i) in worstpart" :key="i">
            <td class="px-1 py-1">{{ part.partname }}</td>
            <td class="px-1 pb-1">{{ part.defect }}</td>
            <td class="px-1 pb-1">{{ part.analysis }}</td>
            <td class="px-1 pb-1">{{ part.tempaction }}</td>
            <td class="px-1 pb-1">{{ part.permanentaction }}</td>
          </tr>
        </table>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { formatDate } from '@shopworx/services/util/date.service';
import WidgetLoading from '../WidgetLoading.vue';

export default {
  name: 'WorstIssueAnalysis',
  props: { scale: { type: Number, default: 1 }, unit: { type: String } },
  components: { WidgetLoading },
  data() {
    return {
      worstpart: [], loading: false, yesterday: '',
    };
  },
  computed: {
    ...mapState('cellwiseQualityDashboard', ['dataFromJSON', 'serverTime', 'currentDate', 'selectedCell']),
    cellname() {
      return this.selectedCell || this.$route.query.selectedcell || '';
    },
  },
  watch: {
    cellname: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.fetchData(true);
        }
      },
    },
    currentDate(newVal, oldVal) {
      if (newVal && newVal !== oldVal && !this.dataFromJSON) {
        this.fetchData();
      }
    },
  },
  mounted() {
    if (this.dataFromJSON) this.dummydata();
    else this.fetchData(true);
  },
  methods: {
    ...mapActions('cellwiseQualityDashboard', ['getRecords', 'getFileData']),

    async dummydata() {
      const res = await this.getFileData('jsondata/worstissueanalysis.json');
      this.setOptions(res.reportData || []);
      const startdate = new Date();
      startdate.setDate(startdate.getDate() - 1);
      this.setTitle(startdate);
    },

    async fetchData(isLoading) {
      if (isLoading) {
        this.loading = true;
      }

      try {
        const elementName = 'worstissueanalysis';
        let query = '?sortquery=createdTimestamp==-1&pagesize=3&pagenumber=1';
        if (this.cellname) {
          query = `?query=cellname=="${this.cellname}"&sortquery=createdTimestamp==-1&pagesize=3&pagenumber=1`;
        }

        const result = await this.getRecords({ elementName, query });
        if (result) {
          this.setOptions(result);
        }

        if (this.currentDate) {
          const dateStr = String(this.currentDate);
          const year = parseInt(dateStr.slice(0, 4), 10);
          const month = parseInt(dateStr.slice(4, 6), 10) - 1;
          const day = parseInt(dateStr.slice(6, 8), 10);

          const targetDate = new Date(year, month, day);
          targetDate.setDate(targetDate.getDate() - 1);
          this.setTitle(targetDate);
        } else {
          const fallbackDate = new Date();
          fallbackDate.setDate(fallbackDate.getDate() - 1);
          this.setTitle(fallbackDate);
        }
      } catch (error) {
        console.error('WorstIssueAnalysis Fetch Error:', error);
      } finally {
        this.loading = false;
      }
    },

    setOptions(data) {
      let records = [];
      if (Array.isArray(data)) {
        records = data;
      } else if (data && Array.isArray(data.results)) {
        records = data.results;
      } else if (data && data.reportData) {
        records = Array.isArray(data.reportData) ? data.reportData : [];
      }

      const parsedData = records.map((item) => item.elementData || item);

      this.worstpart = parsedData.map((part) => ({
        partname: part.partname || '-',
        defect: part.defect || '-',
        analysis: part.analysis || '-',
        tempaction: part.tempaction || '-',
        permanentaction: part.permanentaction || '-',
      }));
    },

    setTitle(val) {
      this.yesterday = formatDate(val, 'dd/MM/yyyy');
    },
  },
};
</script>

<style scoped>
.w-full { width: 100%; }
table, th, td { border: 1px solid #fff; border-collapse: collapse; }
</style>
